module.exports = __webpack_public_path__ + "media/application-logos/buildout-connect-horizontal-navy-89aa7caa.svg";